import { render, staticRenderFns } from "./IndicadoresEsb.vue?vue&type=template&id=5834a9e8"
import script from "./IndicadoresEsb.vue?vue&type=script&lang=js"
export * from "./IndicadoresEsb.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports